/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=c9ee6018"
const script = {}

import "./App.vue?vue&type=style&index=0&id=c9ee6018&lang=less"

import exportComponent from "/Users/iwowke/Desktop/work/www/iwowke.com/src/m/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__